/*對單頁 */
import React, { useState, useContext, useEffect, useMemo } from "react";
import { withRouter } from "react-router-dom";
import { Global } from "../../App";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { CusButton } from "../../Components/From/Button";
import { CusInput } from "../../Components/From/Input";
import { CusCheckboxOne } from "../../Components/From/CheckboxOne";
import { CusRadio } from "../../Components/From/Radio";
import Tool_dropDown from "../../Components/Tools/Tool_dropDown";
import { AsyncModel, AsyncModelClose } from "../AsyncModel/AsyncModel";
import ReactLoading from "react-loading";
import Tool_mealList from "../../Components/Tools/Tool_mealList";
import Tool_extraNeedLIst_staff from "../../Components/Tools/Tool_extraNeedLIst_staff";
import Tool_extraNeedLIst_forStaff from "../Tools/Tool_extraNeedLIst_forStaff";
import Tool_extraNeedStaff from "../Tools/Tool_extraNeedStaff";
import Tool_CusSp from "../../Components/Tools/Tool_CusSp";
import Tool_CusOtherNeed_staff from "../../Components/Tools/Tool_CusOtherNeed_staff";
// import Tool_printOrder from '../../Components/Tools/Tool_printOrder';F
import Tool_printIcon from "../../Components/Tools/Tool_printIcon";
import _ from "lodash";
import cls from "classnames";
import moment from "moment";
import { flatten } from "lodash";
// switch lang
import {
  langStringToCode,
  langCodeToString,
} from "../../Share/Tools/switchLang";
// api test
import {
  getOrderInfo,
  updateOrderPreperationStatus,
  postSaveOrder,
  postAddSaveOrder,
} from "../../Api/staff/GetOrderInfo";
import { getTranslationStaffInfo } from "../../Api/staff/GetStaffInfo";
import { getAllCountry } from "../../Api/GetCountry";
import calcTotal from "../../Share/Tools/calcTotal";
import { getBranchProduct } from "../../Api/GetProduct";
import { getAllProduct } from "../../Api/GetProduct";
import { getOrderProductList } from "../../Api/staff/GetOrderInfo";
import { async } from "rxjs/internal/scheduler/async";
/**
 *
 * @param {object} props
 * 本次步驟會影響的global state
 *
 * staffInfo.currentCheckOrderStep (3 => 2 || 3.1)
 */
function StaffCheckStep_3({ onError, ...props }) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    skipInit: true,
    orderState: globalState.staffInfo.checkOrderData.state,
    dineIn: globalState.staffInfo.checkOrderData.dineIn || [],
    takeout: globalState.staffInfo.checkOrderData.takeout || [],
    orderRemark: globalState.staffInfo.checkOrderData.remark,
    currModify: null,
    isAddNew: false,
    isCheckPrintDetail: false,
    haveTableNo:(globalState.staffInfo.checkOrderData.lineInTable != null && globalState.staffInfo.checkOrderData.lineInTable != ""),
    tableNo: globalState.staffInfo.checkOrderData.lineInTable || "",
    subTableNo: 1,
    specPopupSetting: {
      toggle: false,
      productName: "",
      specName: "",
      dineInTaste: [],
      takeoutTaste: [],
      disableTakeoutState: false,
    },
    popup: {
      toggle: false,
      newData: null,
      target: "",
    },
    popupRemark: {
      orderType: null,
      toggle: false,
      target: null,
      remark: "",
    },
    posCode: "",
    countryList: [],
    numberOfAdult: "",
    numberOfChild: "",
    countrySelected: {
      country: null,
      countryName: null,
    },
    needPopupSetting: {
      toggle: false,
      needName: "",
      subArray: [],
      needId: "",
    },
    extraDataList: [],
  });
  const [refreshPage, setRefreshPage] = useState(false);
  const [isSentOrder, setIsSentOrder] = useState(false);
  const [isExtraCheck, setIsExtraCheck] = useState(false);
  const [isNeedStaffCheckModel, setIsNeedStaffCheckModel] = useState(false);
  const [needStaffCheckID, setneedStaffCheckID] = useState(0);
  
  // 控制備註欄顯示/隱藏
  const ENV_COMMENT_CONTROLLER = process.env.REACT_APP_COMMENT_CONTROLLER === "true";
  // api
  async function apiOrderInfo(
    orderCode,
    langId,
    waiterID,
    storeID,
    createAt,
    Posno,
    Tableno,
    TableNoOf
  ) {
    const goBack = () => {
      const { prevPath } = globalState.staffInfo;
      if (prevPath.search("staffCheckOrder") > -1) {
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            {
              key: "staffInfo",
              val: {
                ...globalState.staffInfo,
                orderCode: "",
                currentCheckOrderStep: "2",
              },
            },
          ],
        });
      } else if (prevPath.search("staffOrderDetail") > -1) {
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            {
              key: "staffInfo",
              val: {
                ...globalState.staffInfo,
              },
            },
          ],
        });
        props.history.push(prevPath);
      }
    };
    try {
      let TableNo = Tableno ? Tableno + "-" + TableNoOf : "";
      let PosNo = Posno;
      let err = 200;

      if (PosNo) {
        // 補齊4碼
        while (PosNo.length < 4) {
          PosNo = `0${PosNo}`;
        }

        PosNo = `${moment(new Date()).format("YYYYMMDD")}${PosNo}`;
      }

      const resStatus = await updateOrderPreperationStatus(
        orderCode,
        langId,
        waiterID,
        storeID,
        createAt,
        Posno,
        TableNo
      );

      const errCodeStatus = resStatus.data.errCode;

      if (errCodeStatus == 200) {
        const resData = await getOrderInfo(
          orderCode,
          langId,
          waiterID,
          storeID,
          createAt,
          Posno,
          TableNo  
        );

        const {errCode, productList} = resData.data;
        
        if(errCode == 200){
          return productList;
        }
        else{
          err = errCode;
        }
      } else {
        err = errCodeStatus;
      }

      if(err != 200){
        const Alert = await AsyncModel({
          title: globalState.langFile[`errorMsg.errorCode_${err}`],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });
        if (Alert) return goBack();
      }
      
    } catch (err) {
      console.error("OrderInfo error.");
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${413}`],
        confirmBtnText: globalState.langFile["popup.buttonConfirm"],
      });
      if (Alert) return goBack();
    }
  }
  async function apiTranslationStaffInfo(staffId, storeId, LangId) {
    try {
      const res = await getTranslationStaffInfo(staffId, storeId, LangId);
      const { errCode, response } = res.data;
      if (errCode == 200) {
        return response;
      } else {
        console.error("TranslationStaffInfo error.", errCode);
      }
    } catch (err) {
      console.error("TranslationStaffInfo error.");
    }
  }
  async function apiSaveOrder(saveData) {
    try {
      let res;
      try {
        // 加點
        if (globalState.staffInfo.checkOrderData.isAddOrder) {
          res = await postAddSaveOrder({
            ...saveData,
            orderCode: globalState.staffInfo.checkOrderData.orderCode,
            mainOrderID: globalState.staffInfo.checkOrderData.mainOrderID,
            mainOrderCode: globalState.staffInfo.checkOrderData.mainOrderCode,
          });
        } else {
          // 第一次點餐
          res = await postSaveOrder(saveData);
        }
      } catch (err) {
        onError(415);
        throw new Error();
      }
      if (res !== undefined) {
        let { errCode, save, messagePOS, posCode, checkTime } = res.data;
        if (save && errCode === 200) {
          if (posCode && checkTime) {
            return { posCode, checkTime };
          } else {
            return true;
          }
        } else {
          if (errCode === 999) {
            onError(errCode, messagePOS);
            throw new Error();
            // 商品售畢，僅返回前一頁
          }   else if (errCode === 5001) {
            onError(errCode, messagePOS, "3");
            throw new Error();
          }
          else if(errCode === 5002){
            //售畢
            const items = messagePOS
            .split("%")
            .slice(0);
            await AsyncModel({
              title: globalState.langFile["erroMsg.erroeCode_5002"],
              content: (
                <div className="w-100 flex flex-col px-2 text-center ">
                  {items.map((item, index) => (
                    <div className="w-100 border-bottom border-light py-2">
                      {" "}
                      <span key={index}>
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              ),
              showConfirmBtn: true,
            });
            setRefreshPage(!refreshPage)
            return;
            // onError(errCode, messagePOS, "3");
          }else if (errCode === 4601) {
            onError(errCode, messagePOS, "3");
            throw new Error();
          } else {
            onError(errCode);
            throw new Error();
          }
        }
      }
    } catch (err) {
      // onError(415)
      throw new Error("error");
      // console.error('OrderInfo error.');
      // dispatchGlobal({
      //   type: 'UPDATE',
      //   payload: [{ key: 'errMsg', val: err.message }]
      // });
      // props.history.push('/staff/error');
      // throw new Error('Orderinfo error.')
    }
  }
  // 取得所有國家
  async function apiAllCountry(langId) {
    try {
      const res = await getAllCountry(langId);
      const { errCode, countryList } = res.data;
      if (errCode == 200) {
        const newCountryList = countryList.map((e) => ({
          title: e.name,
          value: e.id,
        }));
        return newCountryList;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        props.history.push("/staff/error");
      }
    } catch (err) {
      console.error("AllCountry error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 406 }],
      });
      props.history.push("/staff/error");
    }
  }

    // call api
  useEffect(() => {
    const getOrderInfo = async () => {
      const { langType, staffInfo } = globalState;
      try {
        let orderInfo = await apiOrderInfo(
          staffInfo.orderCode,
          globalState.staffInfo.changeOrderLang
            ? langStringToCode(langType)
            : "",
          staffInfo.checkOrderStaff.staffCode,
          staffInfo.checkOrderBranch.branchCode,
          moment(staffInfo.checkOrderData.orderTime).format("YYYY/MM/DD"),
          staffInfo.Posno,
          staffInfo.Tableno,
          staffInfo.TableNoOf
        );
       
        if (orderInfo) {
          let translateStaff = await apiTranslationStaffInfo(
            staffInfo.checkOrderStaff.staffCode,
            staffInfo.checkOrderBranch.branchCode,
            langStringToCode(langType)
          );
           //已經塞過資料就不要覆蓋舊的
        let globalExtra;
        if (globalState.staffInfo.checkOrderData.extraDataList) {
          globalExtra = globalState.staffInfo.checkOrderData.extraDataList;
        } else {
          globalExtra = orderInfo.extraDataList.flatMap((item) => {
            const selectedItems = item.extraOptionList
              .filter((option) => option.selectedMode === 1)
              .map((option) => option.id);

            if (selectedItems.length > 0) {
              return [{ extraId: item.id, selectedItemIDs: selectedItems }];
            }
            return [];
          });
        }
          let extraAns = globalExtra.map(x=>({
            qusetionId:x.extraId,
            ansId:x.selectedItemIDs[0]
          }));

          if(staffInfo.selectedExtraA && staffInfo.selectedExtraA.length > 0){            
            let q = orderInfo.extraDataList.map(x => x.id);
            extraAns = staffInfo.selectedExtraA.filter(x=>q.includes(x.qusetionId));
          }

          let dispatchArray = [
            {
              key: "staffInfo",
              val: {
                ...globalState.staffInfo,
                orderCode: orderInfo.orderCode,
                checkOrderData: {
                  state: orderInfo.status,
                  dineIn: orderInfo.dineIn,
                  takeout: orderInfo.takeout,
                  numberOfAdult: orderInfo.adultsCount,
                  numberOfChild: orderInfo.childCount,
                  orderType: orderInfo.orderType,
                  country: {
                    countryId: orderInfo.countryID,
                    countryName: orderInfo.countryName,
                  },
                  queueNumber: orderInfo.queueNumber,
                  isAddOrder: orderInfo.isAddOrder,
                  posTableNo: orderInfo.posTableNo,
                  mainOrderCode: orderInfo.mainOrderCode,
                  orderCode: orderInfo.orderCode,
                  mainOrderID: orderInfo.mainOrderID,
                  queueCode: orderInfo.queueCode,
                  posCode: orderInfo.posCode,
                  orderTime: orderInfo.createAt,
                  branch: {
                    branchCode: orderInfo.storeID,
                    branchName: orderInfo.storeName,
                  },
                  remark: orderInfo.remark,
                  extraDataList: globalExtra,
                  lineInTable: orderInfo.lineInTable,                  
                  lineInTableNo: orderInfo.lineInTableNo
                },
                checkOrderBranch: {
                  ...globalState.staffInfo.checkOrderBranch,
                  branchName: translateStaff.storeName,
                },
                changeOrderLang: true,
                selectedExtraA:extraAns,
                extraDataList: globalExtra,
              },
            },
          ];
          console.log(
            "globalState.staffInfo.changeOrderLang",
            globalState.staffInfo.changeOrderLang
          );
          // 從順流程進入，使用訂單語系
          if (!globalState.staffInfo.changeOrderLang) {
            dispatchArray.push({
              key: "langType",
              val: langCodeToString(orderInfo.orderLanguageID),
            });
          }
          dispatchGlobal({
            type: "UPDATE",
            payload: dispatchArray,
          });
          setState((curr) => {
            return {
              ...curr,
              haveTableNo:(orderInfo.lineInTable != null && orderInfo.lineInTable != ""),
              extraDataList: orderInfo.extraDataList,
            };
          });
     
          if (globalState.langType === langCodeToString(orderInfo.orderLanguageID)) {
            console.log('同語系 in')
            const langCode = langStringToCode(globalState.langType);
            const storeID = globalState.staffInfo.checkOrderBranch.branchCode;
            const countryCode = globalState.customer.orderInfo.country;
            // const orderCode = globalState.staffInfo.orderCode;
            const orderCode = orderInfo.orderCode;
            const createAt = globalState.staffInfo.createAt;
            const updateCountryList = async () => {
              let countryList = await apiAllCountry(langCode);
              if (countryList) {
                setState((curr) => {
                  let newState = { ...curr };
                  newState.countryList = countryList;
                  return newState;
                });
              }
            };
            updateCountryList();

            const getBranchProductList = async () => {
              let branchProsuctList = await getOrderProductList(
                orderCode,
                langCode,
                storeID,
                createAt
              );

              let mealList =
                branchProsuctList.data.orderAddProduct.categoryList.map((v) => {
                  let type = v.id;
                  let typeName = v.name;
                  let newArr = v.product.map((product) => ({
                    type: type,
                    typeName: typeName,
                    title: product.name,
                    description: product.description,
                    ...product,
                  }));

                  return newArr;
                });
              const mealListAll = flatten(mealList);

              setState((curr) => {
                let newState = { ...curr };
                newState.mealList = mealListAll;
                return newState;
              });
            };

            getBranchProductList();
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    getOrderInfo();
  }, [globalState.langType,refreshPage]);
  

   // 更新state
  useEffect(() => {
    setState((curr) => {
      let sub = 1;
      if(globalState.staffInfo.checkOrderData.lineInTable){
        const numSplit = globalState.staffInfo.checkOrderData.lineInTable.split("-");
        if(numSplit.length > 1){
          sub = parseInt(numSplit[1]);
          if(isNaN(sub)){
            sub = 1;
          }
        }
      }

      return {
        ...curr,
        tableNo: globalState.staffInfo.checkOrderData.lineInTableNo,
        subTableNo: sub,
        dineIn: globalState.staffInfo.checkOrderData.dineIn,
        takeout: globalState.staffInfo.checkOrderData.takeout,        
      };
    });
  }, [globalState.staffInfo.checkOrderData]);

  const $totalPrice = useMemo(() => {
    const { dineIn, takeout } = state;
    const takeoutTotals = calcTotal(takeout);
    const dineInTotals = calcTotal(dineIn);

    return {
      dineInTotalPrice: dineInTotals.total,
      dineInSpecPrice: dineInTotals.tasteTotal,
      takeoutInTotalPrice: takeoutTotals.total,
      takeoutInSpecPrice: takeoutTotals.tasteTotal,
    };
  }, [state]);

  // 計算餐點數量&總金額(餐點單價*數量 + 特口價格*數量)
  const totalPrice = () => {
    return $totalPrice;
  };
  // 四捨五入至小數點第n位
  const formatNumber = (value, pos) => {
    const float = Math.pow(10, pos);
    return (Math.round(value * float) / float).toFixed(pos);
  };

  // 檢查是否有售畢商品
  function haveSoldOut(mealList) {
    return mealList.find((eachMeal) => {
      return eachMeal.specification.some((eachSpec) => {
        // 狀態是售畢
        return (
          eachSpec.status === 3 &&
          eachSpec.combination.some((eachCombi) => {
            // 且數量不為零
            return eachCombi.quantity > 0;
          })
        );
      });
    });
  }

  // 合併同組合條件&刪除組合=0的規格||產品
  function merge(data) {
    if (!data) return null;
    let deep = _.cloneDeep(data);
    let isEquals = (a, b) => {
      return (
        a.takeout === b.takeout &&
        a.taste.sort().toString() === b.taste.sort().toString()
      );
    };
    deep.map((product) => {
      product.specification.map((spec) => {
        const combin = spec.combination.reduce((current, item) => {
          const findIndex = current.findIndex((item1) => isEquals(item, item1));
          if (findIndex === -1) {
            return [...current, item];
          } else {
            const nextCurrent = current.slice(0);
            const isLimit =
              item.quantity + nextCurrent[findIndex].quantity >= 99
                ? 99
                : item.quantity + nextCurrent[findIndex].quantity;
            if (item.quantity + nextCurrent[findIndex].quantity > 99)
              AsyncModel({
                title: globalState.langFile["popup.itemLimit"],
                cancelBtnText: globalState.langFile["popup.buttonCancel"],
                confirmBtnText: globalState.langFile["popup.buttonConfirm"],
              });
            nextCurrent[findIndex] = {
              ...nextCurrent[findIndex],
              quantity: isLimit,
            };
            return nextCurrent;
          }
        }, []);
        spec.combination = combin;
      });
    });

    // 如果規格沒有組合，刪除規格、商品沒有規格，刪除產品
    let parser = deep.filter((product) => {
      let newSpec = product.specification.filter(
        (spec) => spec.combination.length !== 0
      );
      product.specification = newSpec;

      if (product.specification.length !== 0) {
        return product;
      }
    });
    return parser;
  }

  function handlePostOrder(data) {
    let outputFormat = data
      .map((eachProduct) => ({
        id: eachProduct.id,
        remark: eachProduct.remark,
        specification: eachProduct.specification
          .map((eachSpec) => ({
            id: eachSpec.id,
            combination: eachSpec.combination
              .map((eachCombi) => ({
                ...eachCombi,
              }))
              .filter((f) => f.quantity > 0),
          }))
          .filter((f) => f.combination.length > 0),
      }))
      .filter((f) => f.specification.length > 0);
    return outputFormat;
  }

  function calcTotalQuantity() {
    let dineInTotal = 0,
      takeoutTotal = 0;
    state.dineIn.map((eachProduct) => {
      eachProduct.specification.map((eachSpec) => {
        eachSpec.combination.map((eachCombi) => {
          dineInTotal += eachCombi.quantity;
        });
      });
    });
    state.takeout.map((eachProduct) => {
      eachProduct.specification.map((eachSpec) => {
        eachSpec.combination.map((eachCombi) => {
          takeoutTotal += eachCombi.quantity;
        });
      });
    });
    return dineInTotal + takeoutTotal;
  }

  function handlePostOrder(data) {
    let outputFormat = data
      .map((eachProduct) => ({
        id: eachProduct.id,
        remark: eachProduct.remark,
        specification: eachProduct.specification
          .map((eachSpec) => ({
            id: eachSpec.id,
            combination: eachSpec.combination
              .map((eachCombi) => ({
                ...eachCombi,
              }))
              .filter((f) => f.quantity > 0),
          }))
          .filter((f) => f.combination.length > 0),
      }))
      .filter((f) => f.specification.length > 0);
    return outputFormat;
  }

  function calcTotalQuantity() {
    let dineInTotal = 0,
      takeoutTotal = 0;
    state.dineIn.map((eachProduct) => {
      eachProduct.specification.map((eachSpec) => {
        eachSpec.combination.map((eachCombi) => {
          dineInTotal += eachCombi.quantity;
        });
      });
    });
    state.takeout.map((eachProduct) => {
      eachProduct.specification.map((eachSpec) => {
        eachSpec.combination.map((eachCombi) => {
          takeoutTotal += eachCombi.quantity;
        });
      });
    });
    return dineInTotal + takeoutTotal;
  }

  function updateExtraSingle(updateExtraID) {
    let updatedExtraDataList = state.extraDataList.map((extraData) => {
      return {
        ...extraData,
        extraOptionList: extraData.extraOptionList.map((option) =>
          option.id === updateExtraID ? { ...option, selectedMode: 1 } : option
        ),
      };
    });

    setState((curr) => {
      return {
        ...curr,
        extraDataList: updatedExtraDataList,
      };
    });
  }

  function updateExtra(updateExtraIDs, needType, needId) {
    let updatedExtraDataList = state.extraDataList.map((extraData) => {
      return {
        ...extraData,
        extraOptionList: extraData.extraOptionList.map((option) => {
          let selectedMode = option.selectedMode;

          if (extraData.id === needId) {
            // 有選
            if (updateExtraIDs.includes(option.id)) {
              selectedMode = 1;
            }
            // 沒選(包含原本有選然後刪除)
            else {
              selectedMode = 0;
            }
          }

          return { ...option, selectedMode };
        }),
      };
    });

    setState((curr) => {
      return {
        ...curr,
        extraDataList: updatedExtraDataList,
      };
    });
    //為了進去修改出來還有寫到global裡
    let currentSelectedIDs;

    let selectedItem = { extraId: needId, selectedItemIDs: updateExtraIDs };
    let currentSelectedItems;
    const previousSelected = globalState.staffInfo.checkOrderData.extraDataList;

    if (previousSelected) {
      //判斷是否選過

      const itemIndex = previousSelected.findIndex(
        (item) => item.extraId === selectedItem.extraId
      );
      if (itemIndex !== -1) {
        //修改

        let updatedList = [...previousSelected];
        updatedList[itemIndex] = selectedItem;
        currentSelectedItems = updatedList;
        console.log("currentSelectedItems", currentSelectedItems);
      } else {
        //新增一題
        currentSelectedItems = [...previousSelected, selectedItem];
      }
    } else {
      //加第一題
      currentSelectedItems = [selectedItem];
    }

    dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "staffInfo",
          val: {
            ...globalState.staffInfo,
            checkOrderData: {
              ...globalState.staffInfo.checkOrderData,
              extraDataList: currentSelectedItems,
            },
          },
        },
      ],
    });
  }

  // 取消選擇整個附加條件題目
  function removeExtraSelected(removeExtraIDs) {
    const updatedData = state.extraDataList.map((item) => {
      if (item.id === removeExtraIDs) {
        const updatedExtraOptionList = item.extraOptionList.map(
          (extraOption) => ({
            ...extraOption,
            selectedMode: 0,
          })
        );

        return {
          ...item,
          extraOptionList: updatedExtraOptionList,
        };
      }
      return item;
    });

    setState((curr) => {
      return {
        ...curr,
        extraDataList: updatedData,
      };
    });

    //讀global的
    const updatedExtraDataList =
    globalState.staffInfo.checkOrderData.extraDataList.filter(
        (item) => item.extraId !== removeExtraIDs
      );
    dispatchGlobal({
      type: "UPDATE",
      payload: [
        {
          key: "staffInfo",
          val: {
            ...globalState.staffInfo,

            checkOrderData: {
              ...globalState.staffInfo.checkOrderData,
              extraDataList: updatedExtraDataList,
            },
          },
        },
      ],
    });
  }
  // 組合附加選項回傳
  function getExtraSelectedNew(extraData) {
    const combinedSelectedItems =
    globalState.staffInfo.selectedExtraA.map(
      (item) => item.ansId
    );
    
    return combinedSelectedItems;
  }

  return (      
    <>
      {/* <Tool_printIcon /> */}
      <div className="d-flex align-items-center justify-content-center txtColorBrown mb-3">
        
        <span className="m-2">
          {globalState.staffInfo.checkOrderBranch.branchName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderGroup.groupName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffNum}
        </span>
      </div>
      {globalState.staffInfo.checkOrderData.isAddOrder ? (
        <div className="Pages__section align-items-center">
          <div className="Pages__title">
            <div className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__action border-bot-0">
              <p className="txtColorBrown font-bold mt-4 mt-sm-2 mb-sm-2 text-3xl">
                {globalState.staffInfo.checkOrderData.posTableNo}
                {globalState.langFile["pages.staffOrderDetail.table"]}
              </p>
            </div>
          </div>
        </div>
      ) : null}
      <div className="Pages__space">
        <div className="Pages__space__item py-3 ">
          {/* POS單號 */}
          {globalState.staffInfo.checkOrderData.posCode ? (
            <div className="d-flex justify-content-between align-items-center pt-2 pb-2 Pages__specification__title font-weight-bold">
              <div>
                <span className="mr-2">
                  <FormattedMessage id="pages.staffOrderDetail.orderInfo.posNumber" />
                  :
                </span>
                <span className="mr-2">
                  {globalState.staffInfo.checkOrderData.posCode}
                </span>
              </div>
            </div>
          ) : null}
          <div className="d-flex align-items-center p-0 col-12 col-sm-4 pt-2 pb-2">
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.branch.branchName}
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.numberOfAdult}
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.numberOfAdult" />
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.numberOfChild}
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.numberOfChild" />
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.country.countryName}
            </span>
          </div>
          <div className="d-flex flex-wrap">
            <div className="p-0 col-6  pt-2 pb-2">
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.queueNumber" />
              <span className="ml-2 txtColorBrown orderInfo">
                {globalState.staffInfo.checkOrderData.queueNumber}
              </span>
            </div>
            <div className="p-0 col-6  pt-2 pb-2">
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.queueCode" />
              <span className="ml-2 txtColorRed orderInfo">
                {globalState.staffInfo.checkOrderData.queueCode}
              </span>
            </div>
          </div>
          <div className="p-0 col-12  pt-2 pb-2">
            <span className="mr-2">
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.time" />
            </span>
            <span className="mr-2">
              {globalState.staffInfo.checkOrderData.orderTime}
            </span>
          </div>
        </div>
      </div>
      {/* 內用列表 */}
      {/* 判斷鎖菜單號*/}
      {useEffect(() => {
        if (globalState.Hold) {
          const HoldOederCode = String(globalState.Hold.orderCode);
          const localOederCode = String(globalState.staffInfo.orderCode);
          if (HoldOederCode != localOederCode) {
            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "Hold",
                  val: null,
                },
              ],
            });
          }
        }
      }, [])}

      <div className="Pages__section">
        {/* {console.log("state",state)} */}
        {state.dineIn.length > 0 ? (
          state.dineIn.map((eachProduct, productIndex) => (
            <div key={productIndex} className={
              productIndex === state.dineIn.length - 1 ? "" : "border_under"
            }>
                <Tool_mealList
                  deleteButton={true}
                  type="dineIn"
                  device={globalState.device}
                  data={eachProduct}
                  IsMultiLang={true}
                  onDelete={async (newData) => {
                    const alert = await AsyncModel({
                      title: globalState.langFile["popup.msgDelete"],
                      showCancelBtn: true,
                      cancelBtnText: globalState.langFile["popup.buttonCancel"],
                      confirmBtnText:
                        globalState.langFile["popup.buttonConfirm"],
                    });
                    if (alert) {
                      const findTarget = state.dineIn.map((e, index) => {
                        const { id } = e;
                        if (id === newData.newData.id) return newData.newData;
                        return e;
                      });

                      setState((curr) => ({
                        ...curr,
                        dineIn: merge(findTarget),
                      }));

                      dispatchGlobal({
                        type: "UPDATE",
                        payload: [
                          {
                            key: "staffInfo",
                            val: {
                              ...globalState.staffInfo,
                              checkOrderData: {
                                ...globalState.staffInfo.checkOrderData,
                                dineIn: merge(findTarget),
                              },
                            },
                          },
                        ],
                      });
                      const total =
                        totalPrice().dineInTotalPrice +
                        totalPrice().dineInSpecPrice +
                        totalPrice().takeoutInTotalPrice +
                        totalPrice().takeoutInSpecPrice;
                      const { staffInfo } = globalState;
                      const saveData = {
                        waiterID: staffInfo.checkOrderStaff.staffCode,
                        orderCode: staffInfo.orderCode,
                        remark: state.orderRemark,
                        totalPrice: total,
                        dineIn: merge(findTarget),
                        takeout: handlePostOrder(state.takeout),
                        status: 6,
                        storeID: staffInfo.checkOrderBranch.branchCode,
                        createAt: moment(
                          staffInfo.checkOrderData.orderTime
                        ).format("YYYY/MM/DD"),
                      };
                      try {
                        await apiSaveOrder(saveData);
                      } catch (err) {}
                    }
                  }}
                  onUpdate={async (newData) => {
                    setState((curr) => {
                      let newState = { ...curr };
                      newState.dineIn[productIndex] = newData;
                      newState.dineIn = merge(newState.dineIn);
                      return newState;
                    });
                    // const total =
                    //   totalPrice().dineInTotalPrice +
                    //   totalPrice().dineInSpecPrice +
                    //   totalPrice().takeoutInTotalPrice +
                    //   totalPrice().takeoutInSpecPrice;

                    /*
                  const { staffInfo } = globalState;
                  const saveData = {
                    waiterID: staffInfo.checkOrderStaff.staffCode,
                    orderCode: staffInfo.orderCode,
                    remark: state.orderRemark,
                    totalPrice: total,
                    dineIn: handlePostOrder(state.dineIn),
                    takeout: handlePostOrder(state.takeout),
                    status: 6,
                    storeID: staffInfo.checkOrderBranch.branchCode,
                    createAt: moment(staffInfo.checkOrderData.orderTime).format(
                      "YYYY/MM/DD"
                    ),
                  };
                  try {
                    await apiSaveOrder(saveData);
                  } catch (err) {}
                  */
                  }}
                  onEditTaste={(newData) => {
                    const { currModify, specPopupSetting } = newData;
                    setState((curr) => {
                      return {
                        ...curr,
                        isAddNew: false,
                        currModify: currModify,
                        specPopupSetting: specPopupSetting,
                      };
                    });
                  }}
                  onAddNewSpec={(newData) => {
                    const { currModify, specPopupSetting } = newData;
                    setState((curr) => {
                      return {
                        ...curr,
                        isAddNew: newData.isAddNew,
                        specPopupSetting: specPopupSetting,
                        currModify: currModify,
                      };
                    });

                    // // 要新增的組合是否有特口
                    // const { hasSpecTaste } = newCurrModify;
                    // // 無特口
                    // if (!hasSpecTaste) {
                    //   // 新的組合要分配到的分類(外帶/內用)
                    //   let whichTaste = newCurrModify.currModify.takeout
                    //     ? state.takeout
                    //     : state.dineIn;
                    //   whichTaste = _.cloneDeep(whichTaste);
                    //   // 檢查分類(外帶/內用)有無此新組合所屬的產品
                    //   let isProductExist = whichTaste.find(
                    //     product => product.id === newCurrModify.currModify.productId
                    //   );
                    //   let isSpecExist;
                    //   // 有此產品 -> 繼續找出有無此新組合所屬的規格
                    //   if (isProductExist) {
                    //     isSpecExist = isProductExist.specification.find(
                    //       spce => spce.id === newCurrModify.currModify.specId
                    //     );
                    //   }
                    //   // 新的組合原本所屬的分類
                    //   let originalSource = state.dineIn;
                    //   // newCurrModify.currModify.takeout
                    //   //   ? state.dineIn
                    //   //   : state.takeout;
                    //   // 新的組合原本所屬的產品
                    //   let findOriginalProduct = originalSource.find(
                    //     f => f.id === newCurrModify.currModify.productId
                    //   );
                    //   // 新的組合原本所屬的規格
                    //   let findOriginalSpec = findOriginalProduct.specification.find(
                    //     f => f.id === newCurrModify.currModify.specId
                    //   );
                    //   // 分類無此新組合所屬的產品
                    //   if (!isProductExist) {
                    //     console.log('did not have this product');
                    //     // 建立一個新的product -> spec -> combi(新組合)
                    //     let buildNewProduct = {
                    //       ...findOriginalProduct,
                    //       specification: [
                    //         {
                    //           ...findOriginalSpec,
                    //           combination: [
                    //             {
                    //               takeout: newCurrModify.currModify.takeout,
                    //               quantity: newCurrModify.currModify.quantity,
                    //               taste: newCurrModify.currModify.taste
                    //             }
                    //           ]
                    //         }
                    //       ]
                    //     };
                    //     whichTaste = [...whichTaste, buildNewProduct];
                    //     whichTaste.sort((a, b) => {
                    //       return a.id > b.id ? 1 : -1;
                    //     });
                    //   } // 分類無此新組合所屬的規格
                    //   else if (!isSpecExist) {
                    //     console.log('did not have this spec');
                    //     // 建立一個新的spec -> combi(新組合)
                    //     let spec = {
                    //       ...findOriginalSpec,
                    //       combination: [
                    //         {
                    //           takeout: newCurrModify.currModify.takeout,
                    //           quantity: newCurrModify.currModify.quantity,
                    //           taste: newCurrModify.currModify.taste
                    //         }
                    //       ]
                    //     };
                    //     isProductExist.specification = [
                    //       ...isProductExist.specification,
                    //       spec
                    //     ];
                    //     isProductExist.specification.sort((a, b) => {
                    //       return a.id > b.id ? 1 : -1;
                    //     });
                    //   } // 分類無此新組合所屬的產品 && 分類有此新組合所屬的規格
                    //   else {
                    //     isSpecExist.combination = [
                    //       ...isSpecExist.combination,
                    //       {
                    //         takeout: newCurrModify.currModify.takeout,
                    //         quantity: newCurrModify.currModify.quantity,
                    //         taste: newCurrModify.currModify.taste
                    //       }
                    //     ];
                    //   }
                    //   if (newCurrModify.currModify.takeout) {
                    //     setState(curr => {
                    //       let newState = { ...curr };
                    //       newState.takeout = merge(whichTaste);
                    //       newState.currModify = null;
                    //       newState.specPopupSetting = {
                    //         toggle: false,
                    //         productName: '',
                    //         specName: '',
                    //         itemList: [],
                    //         selectedItem: []
                    //       };
                    //       return newState;
                    //     });
                    //   } else {
                    //     setState(curr => {
                    //       let newState = { ...curr };
                    //       newState.dineIn = merge(whichTaste);
                    //       newState.currModify = null;
                    //       newState.specPopupSetting = {
                    //         toggle: false,
                    //         productName: '',
                    //         specName: '',
                    //         itemList: [],
                    //         selectedItem: []
                    //       };
                    //       return newState;
                    //     });
                    //   }
                    // } // 有特口 => 開啟彈跳視窗
                    // else {
                    //   setState(curr => {
                    //     let newState = { ...curr };
                    //     newState.currModify = newCurrModify.currModify;
                    //     newState.specPopupSetting = newCurrModify.specPopupSetting;
                    //     newState.isAddNew = newCurrModify.isAddNew;
                    //     return newState;
                    //   });
                    // }
                  }}
                  onSwitch={(newCurrModify) => {
                    // 新的組合要分配到的分類(外帶/內用)
                    let whichTaste = newCurrModify.currModify.takeout
                      ? state.takeout
                      : state.dineIn;
                    whichTaste = _.cloneDeep(whichTaste);
                    // 檢查分類(外帶/內用)有無此新組合所屬的產品
                    let isProductExist = whichTaste.find(
                      (product) =>
                        product.id === newCurrModify.currModify.productId
                    );
                    let isSpecExist;
                    // 有此產品 -> 繼續找出有無此新組合所屬的規格
                    if (isProductExist) {
                      isSpecExist = isProductExist.specification.find(
                        (spce) => spce.id === newCurrModify.currModify.specId
                      );
                    }
                    // 新的組合原本所屬的分類
                    let originalSource = newCurrModify.currModify.takeout
                      ? state.dineIn
                      : state.takeout;
                    // 新的組合原本所屬的產品
                    let findOriginalProduct = originalSource.find(
                      (f) => f.id === newCurrModify.currModify.productId
                    );
                    // 新的組合原本所屬的規格
                    let findOriginalSpec =
                      findOriginalProduct.specification.find(
                        (f) => f.id === newCurrModify.currModify.specId
                      );

                    // 分類無此新組合所屬的產品
                    if (!isProductExist) {
                      console.log("did not have this product");
                      // 建立一個新的product -> spec -> combi(新組合)
                      let buildNewProduct = {
                        ...findOriginalProduct,
                        specification: [
                          {
                            ...findOriginalSpec,
                            combination: [
                              {
                                takeout: newCurrModify.currModify.takeout,
                                quantity: newCurrModify.currModify.quantity,
                                taste: newCurrModify.currModify.taste,
                              },
                            ],
                          },
                        ],
                      };
                      whichTaste = [...whichTaste, buildNewProduct];
                      whichTaste.sort((a, b) => {
                        return a.id > b.id ? 1 : -1;
                      });
                    } // 分類無此新組合所屬的規格
                    else if (!isSpecExist) {
                      console.log("did not have this spec");
                      // 建立一個新的spec -> combi(新組合)
                      let spec = {
                        ...findOriginalSpec,
                        combination: [
                          {
                            takeout: newCurrModify.currModify.takeout,
                            quantity: newCurrModify.currModify.quantity,
                            taste: newCurrModify.currModify.taste,
                          },
                        ],
                      };
                      isProductExist.specification = [
                        ...isProductExist.specification,
                        spec,
                      ];
                      isProductExist.specification.sort((a, b) => {
                        return a.id > b.id ? 1 : -1;
                      });
                    } // 分類無此新組合所屬的產品 && 分類有此新組合所屬的規格
                    else {
                      isSpecExist.combination = [
                        ...isSpecExist.combination,
                        {
                          takeout: newCurrModify.currModify.takeout,
                          quantity: newCurrModify.currModify.quantity,
                          taste: newCurrModify.currModify.taste,
                        },
                      ];
                    }
                    if (newCurrModify.currModify.takeout) {
                      setState((curr) => {
                        let newState = { ...curr };
                        newState.takeout = merge(whichTaste);
                        return newState;
                      });
                    } else {
                      setState((curr) => {
                        let newState = { ...curr };
                        newState.dineIn = merge(whichTaste);
                        return newState;
                      });
                    }
                  }}
                  onModify={async () => {
                    let findProduct = state.mealList.find(
                      (e) => e.id === eachProduct.id
                    );
                    {
                      console.log("state.mealList", state.mealList);
                    }

                    // const total =
                    //   totalPrice().dineInTotalPrice +
                    //   totalPrice().dineInSpecPrice +
                    //   totalPrice().takeoutInTotalPrice +
                    //   totalPrice().takeoutInSpecPrice;
                    /*
                  const { staffInfo } = globalState;
                  const saveData = {
                    waiterID: staffInfo.checkOrderStaff.staffCode,
                    orderCode: staffInfo.orderCode,
                    remark: state.orderRemark,
                    totalPrice: total,
                    dineIn: handlePostOrder(state.dineIn),
                    takeout: handlePostOrder(state.takeout),
                    status: 6,
                    storeID: staffInfo.checkOrderBranch.branchCode,
                    createAt: moment(staffInfo.checkOrderData.orderTime).format(
                      "YYYY/MM/DD"
                    ),
                  };
                  try {
                    await apiSaveOrder(saveData);
                  } catch (err) {}
                  */
                    dispatchGlobal({
                      type: "UPDATE",
                      payload: [
                        {
                          key: "staffInfo",
                          val: {
                            ...globalState.staffInfo,
                            currentCheckOrderStep: "3.2",
                            isFromOrderDetail: true,
                            currMealDetail: {
                              ...findProduct,
                              mealTag: findProduct.allergen.concat(
                                findProduct.recommend
                              ),
                            },
                          },
                        },
                      ],
                    });
                  }}
                />
              {ENV_COMMENT_CONTROLLER && (
                <div
                  className="d-flex justify-content-between align-items-center pt-1 pb-4 pr-3 pl-3"
                  style={{ borderBottom: "1px solid #b4b4b4" }}
                >
                  <span
                    className={cls(
                      "text-break p-0",
                      state.orderState ? "col-8" : "col"
                    )}
                  >
                    {eachProduct.remark ? (
                      eachProduct.remark
                    ) : (
                      <FormattedMessage id="pages.staffCheckOrder.step3.ifNoteEmpty" />
                    )}
                  </span>
                  {state.orderState && (
                    <div className="d-flex justify-content-end col-4 p-0">
                      <CusButton.White
                        icon="icn ic_order_addmemo__mobile mr-2"
                        onClick={() => {
                          setState((curr) => {
                            return {
                              ...curr,
                              popupRemark: {
                                orderType: "dineIn",
                                toggle: true,
                                target: eachProduct.id,
                                remark: eachProduct.remark,
                              },
                            };
                          });
                        }}
                      >
                        <FormattedMessage id="pages.staffCheckOrder.step3.buttonNote" />
                      </CusButton.White>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="mt-3 text-center">
            <FormattedMessage id="pages.staffCheckOrder.step3.dineInNotExist" />
          </div>
        )}
      </div>
      {/* 外帶列表 */}
      <div className="Pages__section">
        {(() => {
          if (state.takeout.length <= 0) return null;
          return (
            <>
              <div className="Pages__space">
                <div className="Pages__specification__title txtColorDarkBrown  Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                  <FormattedMessage id="pages.staffCheckOrder.step3.takeOrder" />
                </div>
              </div>
              {state.takeout.map((eachProduct, productIndex) => (
                <div key={productIndex}>
                  <div
                    className={
                      productIndex === state.takeout.length - 1
                        ? ""
                        : "border_under"
                    }
                  >
                    <Tool_mealList
                      deleteButton={true}
                      type="takeout"
                      device={globalState.device}
                      data={eachProduct}
                      IsMultiLang={true}
                      onDelete={async (newData) => {
                        const alert = await AsyncModel({
                          title: globalState.langFile["popup.msgDelete"],
                          showCancelBtn: true,
                          cancelBtnText:
                            globalState.langFile["popup.buttonCancel"],
                          confirmBtnText:
                            globalState.langFile["popup.buttonConfirm"],
                        });
                        if (alert) {
                          const findTarget = state.takeout.map((e, index) => {
                            const { id } = e;
                            if (id === newData.newData.id)
                              return newData.newData;
                            return e;
                          });
                          setState((curr) => ({
                            ...curr,
                            takeout: merge(findTarget),
                          }));
                          const total =
                            totalPrice().dineInTotalPrice +
                            totalPrice().dineInSpecPrice +
                            totalPrice().takeoutInTotalPrice +
                            totalPrice().takeoutInSpecPrice;
                          const { staffInfo } = globalState;
                          const saveData = {
                            waiterID: staffInfo.checkOrderStaff.staffCode,
                            orderCode: staffInfo.orderCode,
                            remark: state.orderRemark,
                            totalPrice: total,
                            dineIn: handlePostOrder(state.dineIn),
                            takeout: merge(findTarget),
                            status: 6,
                            storeID: staffInfo.checkOrderBranch.branchCode,
                            createAt: moment(
                              staffInfo.checkOrderData.orderTime
                            ).format("YYYY/MM/DD"),
                          };
                          try {
                            await apiSaveOrder(saveData);
                          } catch (err) {}
                        }
                      }}
                      onUpdate={async (newData) => {
                        setState((curr) => {
                          let newState = { ...curr };
                          newState.takeout[productIndex] = newData;
                          newState.takeout = merge(newState.takeout);
                          return newState;
                        });
                        // const total =
                        //   totalPrice().dineInTotalPrice +
                        //   totalPrice().dineInSpecPrice +
                        //   totalPrice().takeoutInTotalPrice +
                        //   totalPrice().takeoutInSpecPrice;
                        /*
                      const { staffInfo } = globalState;
                      const saveData = {
                        waiterID: staffInfo.checkOrderStaff.staffCode,
                        orderCode: staffInfo.orderCode,
                        remark: state.orderRemark,
                        totalPrice: total,
                        dineIn: handlePostOrder(state.dineIn),
                        takeout: handlePostOrder(state.takeout),
                        status: 6,
                        storeID: staffInfo.checkOrderBranch.branchCode,
                        createAt: moment(
                          staffInfo.checkOrderData.orderTime
                        ).format("YYYY/MM/DD"),
                      };
                      try {
                        await apiSaveOrder(saveData);
                      } catch (err) {}
                      */
                      }}
                      onEditTaste={(newData) => {
                        // setState(curr => {
                        //   return {
                        //     ...curr,
                        //     isAddNew: false,
                        //     currModify: newData.currModify,
                        //     specPopupSetting: {
                        //       toggle: true,
                        //       productName: newData.productName,
                        //       specName: newData.specName,
                        //       itemList: newData.itemList,
                        //       selectedItem: newData.selectedItem
                        //     }
                        //   };
                        // });
                        const { currModify, specPopupSetting } = newData;
                        setState((curr) => {
                          return {
                            ...curr,
                            isAddNew: false,
                            currModify: currModify,
                            specPopupSetting: specPopupSetting,
                          };
                        });
                      }}
                      onAddNewSpec={(newData) => {
                        setState((curr) => {
                          return {
                            ...curr,
                            isAddNew: newData.isAddNew,
                            specPopupSetting: {
                              toggle: newData.specPopupSetting.toggle,
                              productName: newData.specPopupSetting.productName,
                              specName: newData.specPopupSetting.specName,
                              dineInTaste: newData.specPopupSetting.dineInTaste,
                              takeoutTaste:
                                newData.specPopupSetting.takeoutTaste,
                              applyMode: newData.specPopupSetting.applyMode,
                            },
                            currModify: newData.currModify,
                          };
                        });
                        // // 要新增的組合是否有特口
                        // const { hasSpecTaste } = newCurrModify;
                        // // 無特口
                        // if (!hasSpecTaste) {
                        //   // 新的組合要分配到的分類(外帶/內用)
                        //   let whichTaste = newCurrModify.currModify.takeout
                        //     ? state.takeout
                        //     : state.dineIn;
                        //   whichTaste = _.cloneDeep(whichTaste);
                        //   // 檢查分類(外帶/內用)有無此新組合所屬的產品
                        //   let isProductExist = whichTaste.find(
                        //     product =>
                        //       product.id === newCurrModify.currModify.productId
                        //   );
                        //   let isSpecExist;
                        //   // 有此產品 -> 繼續找出有無此新組合所屬的規格
                        //   if (isProductExist) {
                        //     isSpecExist = isProductExist.specification.find(
                        //       spce => spce.id === newCurrModify.currModify.specId
                        //     );
                        //   }
                        //   // 新的組合原本所屬的分類
                        //   let originalSource = state.takeout;
                        //   // newCurrModify.currModify.takeout
                        //   //   ? state.takeout
                        //   //   : state.dineIn;
                        //   // 新的組合原本所屬的產品
                        //   let findOriginalProduct = originalSource.find(
                        //     f => f.id === newCurrModify.currModify.productId
                        //   );
                        //   // 新的組合原本所屬的規格
                        //   let findOriginalSpec = findOriginalProduct.specification.find(
                        //     f => f.id === newCurrModify.currModify.specId
                        //   );
                        //   // 分類無此新組合所屬的產品
                        //   if (!isProductExist) {
                        //     console.log('did not have this product');
                        //     // 建立一個新的product -> spec -> combi(新組合)
                        //     let buildNewProduct = {
                        //       ...findOriginalProduct,
                        //       specification: [
                        //         {
                        //           ...findOriginalSpec,
                        //           combination: [
                        //             {
                        //               takeout: newCurrModify.currModify.takeout,
                        //               quantity: newCurrModify.currModify.quantity,
                        //               taste: newCurrModify.currModify.taste
                        //             }
                        //           ]
                        //         }
                        //       ]
                        //     };
                        //     whichTaste = [...whichTaste, buildNewProduct];
                        //     whichTaste.sort((a, b) => {
                        //       return a.id > b.id ? 1 : -1;
                        //     });
                        //   } // 分類無此新組合所屬的規格
                        //   else if (!isSpecExist) {
                        //     console.log('did not have this spec');
                        //     // 建立一個新的spec -> combi(新組合)
                        //     let spec = {
                        //       ...findOriginalSpec,
                        //       combination: [
                        //         {
                        //           takeout: newCurrModify.currModify.takeout,
                        //           quantity: newCurrModify.currModify.quantity,
                        //           taste: newCurrModify.currModify.taste
                        //         }
                        //       ]
                        //     };
                        //     isProductExist.specification = [
                        //       ...isProductExist.specification,
                        //       spec
                        //     ];
                        //     isProductExist.specification.sort((a, b) => {
                        //       return a.id > b.id ? 1 : -1;
                        //     });
                        //   } // 分類無此新組合所屬的產品 && 分類有此新組合所屬的規格
                        //   else {
                        //     isSpecExist.combination = [
                        //       ...isSpecExist.combination,
                        //       {
                        //         takeout: newCurrModify.currModify.takeout,
                        //         quantity: newCurrModify.currModify.quantity,
                        //         taste: newCurrModify.currModify.taste
                        //       }
                        //     ];
                        //   }
                        //   if (newCurrModify.currModify.takeout) {
                        //     setState(curr => {
                        //       let newState = { ...curr };
                        //       newState.takeout = merge(whichTaste);
                        //       newState.currModify = null;
                        //       newState.specPopupSetting = {
                        //         toggle: false,
                        //         productName: '',
                        //         specName: '',
                        //         itemList: [],
                        //         selectedItem: []
                        //       };
                        //       return newState;
                        //     });
                        //   } else {
                        //     setState(curr => {
                        //       let newState = { ...curr };
                        //       newState.dineIn = merge(whichTaste);

                        //       newState.specPopupSetting = {
                        //         toggle: false,
                        //         productName: '',
                        //         specName: '',
                        //         itemList: [],
                        //         selectedItem: []
                        //       };
                        //       return newState;
                        //     });
                        //   }
                        // } // 有特口 => 開啟彈跳視窗
                        // else {
                        //   setState(curr => {
                        //     let newState = { ...curr };
                        //     newState.currModify = newCurrModify.currModify;
                        //     newState.specPopupSetting =
                        //       newCurrModify.specPopupSetting;
                        //     newState.isAddNew = newCurrModify.isAddNew;
                        //     return newState;
                        //   });
                        // }
                      }}
                      onSwitch={(newCurrModify) => {
                        // 新的組合要分配到的分類(外帶/內用)
                        let whichTaste = newCurrModify.currModify.takeout
                          ? state.takeout
                          : state.dineIn;
                        whichTaste = _.cloneDeep(whichTaste);
                        // 檢查分類(外帶/內用)有無此新組合所屬的產品
                        let isProductExist = whichTaste.find(
                          (product) =>
                            product.id === newCurrModify.currModify.productId
                        );
                        let isSpecExist;
                        // 有此產品 -> 繼續找出有無此新組合所屬的規格
                        if (isProductExist) {
                          isSpecExist = isProductExist.specification.find(
                            (spce) =>
                              spce.id === newCurrModify.currModify.specId
                          );
                        }
                        // 新的組合原本所屬的分類
                        let originalSource = newCurrModify.currModify.takeout
                          ? state.dineIn
                          : state.takeout;
                        // 新的組合原本所屬的產品
                        let findOriginalProduct = originalSource.find(
                          (f) => f.id === newCurrModify.currModify.productId
                        );
                        // 新的組合原本所屬的規格
                        let findOriginalSpec =
                          findOriginalProduct.specification.find(
                            (f) => f.id === newCurrModify.currModify.specId
                          );
                        // 分類無此新組合所屬的產品
                        if (!isProductExist) {
                          console.log("did not have this product");
                          // 建立一個新的product -> spec -> combi(新組合)
                          let buildNewProduct = {
                            ...findOriginalProduct,
                            specification: [
                              {
                                ...findOriginalSpec,
                                combination: [
                                  {
                                    takeout: newCurrModify.currModify.takeout,
                                    quantity: newCurrModify.currModify.quantity,
                                    taste: newCurrModify.currModify.taste,
                                  },
                                ],
                              },
                            ],
                          };
                          whichTaste = [...whichTaste, buildNewProduct];
                          whichTaste.sort((a, b) => {
                            return a.id > b.id ? 1 : -1;
                          });
                        } // 分類無此新組合所屬的規格
                        else if (!isSpecExist) {
                          console.log("did not have this spec");
                          // 建立一個新的spec -> combi(新組合)
                          let spec = {
                            ...findOriginalSpec,
                            combination: [
                              {
                                takeout: newCurrModify.currModify.takeout,
                                quantity: newCurrModify.currModify.quantity,
                                taste: newCurrModify.currModify.taste,
                              },
                            ],
                          };
                          isProductExist.specification = [
                            ...isProductExist.specification,
                            spec,
                          ];
                          isProductExist.specification.sort((a, b) => {
                            return a.id > b.id ? 1 : -1;
                          });
                        } // 分類無此新組合所屬的產品 && 分類有此新組合所屬的規格
                        else {
                          console.log("add new combination");
                          // 直接新增combi(新組合)
                          isSpecExist.combination = [
                            ...isSpecExist.combination,
                            {
                              takeout: newCurrModify.currModify.takeout,
                              quantity: newCurrModify.currModify.quantity,
                              taste: newCurrModify.currModify.taste,
                            },
                          ];
                        }
                        if (newCurrModify.currModify.takeout) {
                          setState((curr) => {
                            let newState = { ...curr };
                            newState.takeout = merge(whichTaste);
                            return newState;
                          });
                        } else {
                          setState((curr) => {
                            let newState = { ...curr };
                            newState.dineIn = merge(whichTaste);
                            return newState;
                          });
                        }
                      }}
                      onModify={async () => {
                        let findProduct = state.mealList.find(
                          (e) => e.id === eachProduct.id
                        );

                        console.log("Modifystate", state);

                        // const total =
                        //   totalPrice().dineInTotalPrice +
                        //   totalPrice().dineInSpecPrice +
                        //   totalPrice().takeoutInTotalPrice +
                        //   totalPrice().takeoutInSpecPrice;
                        /*
                      const { staffInfo } = globalState;
                      const saveData = {
                        waiterID: staffInfo.checkOrderStaff.staffCode,
                        orderCode: staffInfo.orderCode,
                        remark: state.orderRemark,
                        totalPrice: total,
                        dineIn: handlePostOrder(state.dineIn),
                        takeout: handlePostOrder(state.takeout),
                        status: 6,
                        storeID: staffInfo.checkOrderBranch.branchCode,
                        createAt: moment(
                          staffInfo.checkOrderData.orderTime
                        ).format("YYYY/MM/DD"),
                      };
                      try {
                        await apiSaveOrder(saveData);
                      } catch (err) {}
                      */
                        dispatchGlobal({
                          type: "UPDATE",
                          payload: [
                            {
                              key: "staffInfo",
                              val: {
                                ...globalState.staffInfo,
                                currentCheckOrderStep: "3.2",
                                isFromOrderDetail: true,
                                currMealDetail: {
                                  ...findProduct,
                                  mealTag: findProduct.allergen.concat(
                                    findProduct.recommend
                                  ),
                                },
                                // mealDetail: findProduct
                              },
                            },
                          ],
                        });
                      }}
                    />
                  </div>
                  {ENV_COMMENT_CONTROLLER && (
                    <div
                      className="d-flex justify-content-between align-items-center pt-1 pb-4 pr-3 pl-3"
                      style={{ borderBottom: "1px solid #b4b4b4" }}
                    >
                      <span
                        className={cls(
                          "text-break p-0",
                          state.orderState ? "col-8" : "col"
                        )}
                      >
                        {eachProduct.remark ? (
                          eachProduct.remark
                        ) : (
                          <FormattedMessage id="pages.staffCheckOrder.step3.ifNoteEmpty" />
                        )}
                      </span>
                      {state.orderState && (
                        <div className="d-flex justify-content-end col-4 p-0">
                          <CusButton.White
                            icon="icn ic_order_addmemo__mobile mr-2"
                            onClick={() => {
                              setState((curr) => {
                                return {
                                  ...curr,
                                  popupRemark: {
                                    orderType: "takeout",
                                    toggle: true,
                                    target: eachProduct.id,
                                    remark: eachProduct.remark,
                                  },
                                };
                              });
                            }}
                          >
                            <FormattedMessage id="pages.staffCheckOrder.step3.buttonNote" />
                          </CusButton.White>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </>
          );
        })()}
      </div>
       {/* 其他需求 */}
      

       {state.extraDataList.length>0
        ?<>
        <div className="Pages__space">
           {/* 附加需求大分類標題之後有多個題目再加上去 */}
          <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
            <FormattedMessage id="pages.staffCheckOrder.orderInfo.otherNeed" />
          </div>
        </div>
        {state.extraDataList.map((eachExraNeed, eachExraNeedIndex) => (
            //<Tool_extraNeedLIst_staff
            //  key={eachExraNeedIndex}
            //  data={eachExraNeed}
            //  onOpenToggle={(newCurrModify) => {
            // 
            //    setState((curr) => {
            //      return {
            //        ...curr,
            //        needPopupSetting: newCurrModify,
            //      };
            //    });
            //  }}
            //  removeExtraSelected={removeExtraSelected}
            ///>
            <Tool_extraNeedLIst_forStaff
              key={eachExraNeedIndex}
              data={eachExraNeed}
              qId={eachExraNeed.id}
              removeExtraSelected={removeExtraSelected}
              isExtraCheck={isExtraCheck}
              setIsExtraCheck={setIsExtraCheck}
              setIsSentOrder={setIsSentOrder}
              setIsNeedStaffCheckModel={setIsNeedStaffCheckModel}
              setselectedExtra = {()=>{
                let ans = globalState.staffInfo.selectedExtraA;
                
                if(!ans){
                  ans = [];
                }

                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "staffInfo",
                      val: {
                        ...globalState.staffInfo,
                        selectedExtraQ:eachExraNeed,
                        selectedExtraA: ans
                      },
                    },
                  ],
                });
              }}
              needStaffCheckID={needStaffCheckID}
            />
          ))
            }</> : ""}
      {/* 訂單備註 & 價格 */}
      <div className="Pages__section Pages__space mt-2 mt-sm-4 mb-2 mb-sm-4">
        {ENV_COMMENT_CONTROLLER && (
          <>
            <div className="Pages__space__item Pages__specification__title d-flex justify-content-center align-items-center pt-3 pb-3">
              <FormattedMessage id="pages.staffCheckOrder.step3.orderNote" />
            </div>
            <div className="Pages__space__item d-flex justify-content-between align-items-center p-3">
              <span
                className={cls(
                  "text-break p-0",
                  state.orderState ? "col-8" : "col"
                )}
              >
                {state.orderRemark ? (
                  state.orderRemark
                ) : (
                  <FormattedMessage id="pages.staffCheckOrder.step3.ifNoteEmpty" />
                )}
              </span>
              {state.orderState && (
                <div className="d-flex justify-content-end col-4 p-0">
                  <CusButton.White
                    icon="icn ic_order_addmemo__mobile mr-2"
                    onClick={() => {
                      setState((curr) => {
                        return {
                          ...curr,
                          popupRemark: {
                            orderType: "order",
                            toggle: true,
                            remark: state.orderRemark,
                          },
                        };
                      });
                    }}
                  >
                    <FormattedMessage id="pages.staffCheckOrder.step3.buttonNote" />
                  </CusButton.White>
                </div>
              )}
            </div>
          </>
        )}
        <div className="Pages__space__item">
          {/* 合計 */}
          <div className="d-flex pr-3 pl-3">
            <div className="col-4 col-sm-7"></div>
            <div
              className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
              style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
            >
              <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                <FormattedMessage id="pages.staffCheckOrder.step3.sum.price" />
              </div>
              <div translete="no" className="d-flex justify-content-end align-items-center col-6 p-0 orderInfo">
                $
                {formatNumber(
                  totalPrice().dineInSpecPrice +
                    totalPrice().dineInTotalPrice +
                    totalPrice().takeoutInSpecPrice +
                    totalPrice().takeoutInTotalPrice,
                  2
                )}
              </div>
            </div>
          </div>
          {/* 服務費 */}
          <div className="d-flex pr-3 pl-3">
            <div className="col-4 col-sm-7"></div>
            <div
              className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
              style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
            >
              <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                <FormattedMessage id="pages.staffCheckOrder.step3.sum.tips" />
                (10%)
              </div>
              <div
                className="d-flex justify-content-end align-items-center col-6 p-0"
                style={{ fontSize: "20px" }}
                translete="no"
              >
                $
                {formatNumber(
                  (totalPrice().dineInSpecPrice +
                    totalPrice().dineInTotalPrice) *
                    0.1,
                  2
                )}
              </div>
            </div>
          </div>
          {/* 總計 */}
          <div className="d-flex pr-3 pl-3">
            <div className="col-4 col-sm-7"></div>
            <div
              className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
              style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
            >
              <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                <FormattedMessage id="pages.staffCheckOrder.step3.sum.total" />
              </div>
              <div translete="no" className="d-flex justify-content-end align-items-center col-6 p-0 txtColorBrown">
                $
                {formatNumber(
                  (totalPrice().dineInSpecPrice +
                    totalPrice().dineInTotalPrice) *
                    1.1 +
                    totalPrice().takeoutInSpecPrice +
                    totalPrice().takeoutInTotalPrice,
                  2
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {globalState.staffInfo.checkOrderData.orderType === 3 ? (
        <div className="pl-3 pt-3 pr-3 pb-1">
          <div>
            <div className="w-100">
              <FormattedMessage id="pages.staffCheckOrder.step3.numberOfTitle" />
            </div>
            <div className="d-flex w-100">
              <div className="d-flex col-4 p-0">
                <CusInput
                  className="w-100 text-center"
                  value={state.numberOfAdult}
                  type="tel"
                  maxLength={2}
                  placeholder={0}
                  onChange={(event) => {
                    let val = event.target.value;
                    setState((curr) => {
                      let newState = { ...curr };
                      newState.numberOfAdult = Number(val);
                      return newState;
                    });
                  }}
                />
                <span className="text-nowrap d-flex align-items-center mr-2 ml-2">
                  <FormattedMessage id="pages.staffCheckOrder.step3.numberOfAdult" />
                </span>
              </div>
              <div className="d-flex col-4 p-0">
                <CusInput
                  className="w-100 text-center"
                  value={state.numberOfChild}
                  type="tel"
                  maxLength={2}
                  placeholder={0}
                  onChange={(event) => {
                    let val = event.target.value;
                    setState((curr) => {
                      let newState = { ...curr };
                      newState.numberOfChild = Number(val);
                      return newState;
                    });
                  }}
                />
                <span className="text-nowrap d-flex align-items-center mr-2 ml-2">
                  <FormattedMessage id="pages.staffCheckOrder.step3.numberOfChild" />
                </span>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="w-100">
              <FormattedMessage id="pages.staffTakeOrder.step3.countryOfbranch" />
            </div>
            <Tool_dropDown
              items={state.countryList}
              selected={state.countrySelected.country}
              onSelected={(e) => {
                setState((curr) => {
                  let newState = { ...curr };
                  newState.countrySelected = {
                    country: e.value,
                    countryName: e.title,
                  };
                  return newState;
                });
              }}
            />
          </div>
        </div>
      ) : null}
      <div className="pl-3 pt-3 pr-3 pb-1">        
        
        {globalState.staffInfo.checkOrderData.isAddOrder ? (
          ""
        ) : (
          <>
            <div className="d-flex mb-2 justify-content-center align-items-center text-justify text-lg">          
              <FormattedMessage id="pages.staffCheckOrder.orderInfo.lineInTable"/>：
              {globalState.staffInfo.checkOrderData.lineInTable ? 
              (
                <span className="txtColorRed">
                {(globalState.staffInfo.checkOrderData.lineInTable.slice(-1)==="桌")?globalState.staffInfo.checkOrderData.lineInTable.slice(0,-1):globalState.staffInfo.checkOrderData.lineInTable}
                <FormattedMessage id="pages.staffOrderDetail.table" />
                </span>)
              :(<span className="txtColorRed">
                <FormattedMessage id="pages.all.NoTableNumber" />
                </span>)
              }                        
            </div>
            <div className="radioContent">
            <CusRadio
              checked={state.haveTableNo}
              title={
                <>
                  <span className="text-nowrap mr-2">
                    <FormattedMessage id="pages.staffCheckOrder.step3.tableNumber" />
                  </span>
                  <div className="d-inline-block">
                    <div style={{ width: "40px" }}>
                      <CusInput
                        className="text-center"
                        value={state.tableNo}
                        maxLength={3}
                        type="tel"
                        onChange={(event) => {
                          let val = event.target.value;
                          setState((curr) => {
                            return {
                              ...curr,
                              tableNo: val,
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <span className="text-nowrap mr-2 ml-2">-</span>
                  <div className="d-inline-block align-middle">
                    <CusCheckboxOne
                      checked={state.subTableNo === 1}
                      value={1}
                      onChange={(e) => {
                        e.stopPropagation();
                        setState((curr) => {
                          return {
                            ...curr,
                            haveTableNo: true,
                            subTableNo: 1,
                          };
                        });
                      }}
                    />
                  </div>
                  <div className="d-inline-block align-middle">
                    <CusCheckboxOne
                      checked={state.subTableNo === 2}
                      value={2}
                      onChange={(e) => {
                        e.stopPropagation();
                        setState((curr) => {
                          return {
                            ...curr,
                            haveTableNo: true,
                            subTableNo: 2,
                          };
                        });
                      }}
                    />
                  </div>
                  <div className="d-inline-block align-middle">
                    <CusCheckboxOne
                      checked={state.subTableNo === 3}
                      value={3}
                      onChange={(e) => {
                        e.stopPropagation();
                        setState((curr) => {
                          return {
                            ...curr,
                            haveTableNo: true,
                            subTableNo: 3,
                          };
                        });
                      }}
                    />
                  </div>
                </>
              }
              onChange={() => {
                setState((curr) => {
                  return {
                    ...curr,
                    haveTableNo: true,
                    subTableNo: 1,
                  };
                });
              }}
            />
            <CusRadio
              checked={!state.haveTableNo}
              title={
                <span>
                  <FormattedMessage id="pages.staffCheckOrder.step3.skipTableNumber" />
                </span>
              }
              onChange={() => {
                setState((curr) => {
                  return {
                    ...curr,
                    tableNo: "",
                    subTableNo: 0,
                    haveTableNo: false,
                  };
                });
              }}
            />
            </div>
          </>
        )}
      </div>
      <div className="Pages__section">
        <div className="d-flex justify-content-center align-items-center p-3 txtColorRed text-justify">
          <FormattedMessage id="pages.staffCheckOrder.step3.orderNotice" />
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center p-3">
        {/* <CusCheckbox
          checked={state.isCheckPrintDetail}
          title={
            <span>
              <FormattedMessage id="pages.staffCheckOrder.step3.checkPrintDetail" />
            </span>
          }
          onChange={() => {
            setState(curr => {
              return {
                ...curr,
                isCheckPrintDetail: !state.isCheckPrintDetail
              }
            })
          }}
        /> */}
      </div>
      <div className="mt-4 mb-4 d-flex flex-column align-items-center">
        <div style={{ width: "500px" }} className="d-flex mb-2 col p-0">
          {/* 返回上頁 */}
          <CusButton.White
            className="mr-2 mr-sm-3 p-3 col staff-check-step3-back"
            children={
              <FormattedMessage id="pages.staffCheckOrder.step3.buttonBack" />
            }
            onClick={async () => {
              /** 2020/01/21 Added: Back, Save OrderData */
              const total =
                totalPrice().dineInTotalPrice +
                totalPrice().dineInSpecPrice +
                totalPrice().takeoutInTotalPrice +
                totalPrice().takeoutInSpecPrice;
              // 回傳訂單 => 回傳成功 => 重置staff登入狀態至分店
              const handledOrderDineIn = handlePostOrder(state.dineIn);
              const handledOrderTakeout = handlePostOrder(state.takeout);
              const { prevPath } = globalState.staffInfo;
              const staffInfo = globalState.staffInfo;
              const saveData = {
                waiterID: staffInfo.checkOrderStaff.staffCode,
                orderCode: staffInfo.orderCode,
                remark: state.orderRemark,
                totalPrice: total,
                dineIn: handledOrderDineIn,
                takeout: handledOrderTakeout,
                status: 1,
                storeID: staffInfo.checkOrderBranch.branchCode,
                createAt: moment(staffInfo.checkOrderData.orderTime).format(
                  "YYYY/MM/DD"
                ),
              };

              try {
                await apiSaveOrder(saveData);
                if (prevPath === "/staffCheckOrder") {
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [
                      {
                        key: "staffInfo",
                        val: {
                          ...globalState.staffInfo,
                          orderCode: "",
                          checkOrderData: "",
                          currentCheckOrderStep: "2",
                          selectedExtraA:[],
                          selectedExtraQ:{}
                        },
                      },
                    ],
                  });
                } else if (prevPath === "/staffOrderDetail") {
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [
                      {
                        key: "staffInfo",
                        val: {
                          ...globalState.staffInfo,
                          checkOrderData: "",
                          currentCheckOrderStep: "2",
                          selectedExtraA:[],
                          selectedExtraQ:{}
                        },
                      },
                    ],
                  });
                  props.history.push(prevPath);
                }
              } catch (err) {}
            }}
          />
          {/* 加入菜品 */}
          <CusButton.White
            className="ml-2 ml-sm-3 p-3 col staff-check-step3-add"
            disabled={
              moment(globalState.staffInfo.checkOrderData.orderTime)
                .startOf("day")
                .diff(moment().startOf("day"), "days") !== 0
            }
            children={
              <FormattedMessage id="pages.staffCheckOrder.step3.buttonAdd" />
            }
            onClick={async () => {
              const total =
                totalPrice().dineInTotalPrice +
                totalPrice().dineInSpecPrice +
                totalPrice().takeoutInTotalPrice +
                totalPrice().takeoutInSpecPrice;
              const { staffInfo } = globalState;
              const saveData = {
                waiterID: staffInfo.checkOrderStaff.staffCode,
                orderCode: staffInfo.orderCode,
                remark: state.orderRemark,
                totalPrice: total,
                dineIn: handlePostOrder(state.dineIn),
                takeout: handlePostOrder(state.takeout),
                status: 6,
                storeID: staffInfo.checkOrderBranch.branchCode,
                createAt: moment(staffInfo.checkOrderData.orderTime).format(
                  "YYYY/MM/DD"
                ),
              };
              try {
                await apiSaveOrder(saveData);
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "staffInfo",
                      val: {
                        ...globalState.staffInfo,
                        checkOrderData: {
                          ...globalState.staffInfo.checkOrderData,
                          dineIn: state.dineIn,
                          takeout: state.takeout,
                        },
                        filterTag: [],
                        currentCheckOrderStep: "3.1",
                      },
                    },
                  ],
                });
              } catch (err) {}
            }}
          />
        </div>
        {/* 儲存預點單 */}

        <div style={{ width: "500px" }} className="d-flex mt-2 col p-0">
          {
            <CusButton.Red
              className="p-3 col staff-check-step3-save"
              disabled={
                (globalState.staffInfo.checkOrderData.isAddOrder === false &&
                  ((globalState.staffInfo.checkOrderData.orderType === 3 &&
                    ((!state.numberOfAdult && !state.numberOfChild) ||
                      !state.countrySelected.country)) ||
                    (moment(globalState.staffInfo.checkOrderData.orderTime)
                      .startOf("day")
                      .diff(moment().startOf("day"), "days") !== 0,
                    state.dineIn.length + state.takeout.length === 0) ||
                    calcTotalQuantity() === 0 ||
                    // 判斷有無選擇桌號
                    (state.haveTableNo &&
                      (!state.tableNo || !state.subTableNo)) ||
                    // 檢查有無售畢
                    haveSoldOut(state.dineIn) ||
                    haveSoldOut(state.takeout))) ||
                //檢查總合為0
                formatNumber(
                  (totalPrice().dineInSpecPrice +
                    totalPrice().dineInTotalPrice) *
                    1.1 +
                    totalPrice().takeoutInSpecPrice +
                    totalPrice().takeoutInTotalPrice,
                  2
                ) == 0
              }
              children={
                <FormattedMessage
                  id={(() => {
                    const result =
                      haveSoldOut(state.dineIn) || haveSoldOut(state.takeout)
                        ? "buttonHaveSoldOut"
                        : globalState.staffInfo.checkOrderData.isAddOrder ===
                            false &&
                          state.haveTableNo &&
                          (!state.tableNo || !state.subTableNo)
                        ? "buttonDisabledTableNo"
                        : globalState.staffInfo.checkOrderData.isAddOrder
                        ? "SaveAddOrderBtn"
                        : "buttonSave";
                    return `pages.staffCheckOrder.step3.${result}`;
                  })()}
                />
              }
              onClick={async () => {
                const waittingAlert = AsyncModel({
                  content: (
                    <div className="w-100 d-flex justify-content-center">
                      <ReactLoading
                        type="spokes"
                        color="#ccc"
                        height="100px"
                        width="100px"
                      />
                    </div>
                  ),
                  footerMsg:
                    globalState.langFile[
                      globalState.staffInfo.checkOrderData.isAddOrder
                        ? "pages.staffCheckOrder.step3.AddOrderLoading"
                        : "pages.staffCheckOrder.loading"
                    ],
                  showConfirmBtn: false,
                });
                const total =
                  totalPrice().dineInTotalPrice +
                  totalPrice().dineInSpecPrice +
                  totalPrice().takeoutInTotalPrice +
                  totalPrice().takeoutInSpecPrice;
                // 回傳訂單 => 回傳成功 => 重置staff登入狀態至分店

                const handledOrderDineIn = handlePostOrder(state.dineIn);
                const handledOrderTakeout = handlePostOrder(state.takeout);
                if (
                  handledOrderDineIn.length <= 0 &&
                  handledOrderTakeout.length <= 0
                ) {
                  console.error("OrderInfo error.");
                  dispatchGlobal({
                    type: "UPDATE",
                    payload: [{ key: "errMsg", val: 415 }],
                  });
                  props.history.push("/staff/error");
                } else {
                  const { staffInfo } = globalState;
                  const saveData = {
                    waiterID: staffInfo.checkOrderStaff.staffCode,
                    orderCode: staffInfo.orderCode,
                    remark: state.orderRemark,
                    totalPrice: total,
                    tableNumber: state.tableNo
                      ? `${state.tableNo}-${state.subTableNo}`
                      : "",
                    dineIn: handledOrderDineIn,
                    takeout: handledOrderTakeout,
                    status: 2,
                    storeID: staffInfo.checkOrderBranch.branchCode,
                    createAt: moment(staffInfo.checkOrderData.orderTime).format(
                      "YYYY/MM/DD"
                    ),
                    orderExtraList: getExtraSelectedNew(staffInfo.selectedExtraA),
                  };

                  // 若是QRCODE點餐，帶人數跟國別進request
                  if (globalState.staffInfo.checkOrderData.orderType === 3) {
                    saveData.adultsCount = state.numberOfAdult || 0;
                    saveData.childCount = state.numberOfChild || 0;
                    saveData.countryID = state.countrySelected.country;
                  }
                  
                  try {
                    let q = state.extraDataList.map(x=>x.id); 
                    let a = staffInfo.selectedExtraA.map(x=>x.qusetionId);                    
                    let result = q.concat(a).filter(v=>!q.includes(v) || !a.includes(v));
                    if(result.length > 0){    
                      let first = state.extraDataList.filter(x=>x.id == result[0])[0];
                      console.debug(first);                     
                      dispatchGlobal({
                        type: "UPDATE",
                        payload: [
                          {
                            key: "staffInfo",
                            val: {
                              ...globalState.staffInfo,
                              selectedExtraQ:first
                            },
                          },
                        ],
                      });
                      setIsSentOrder(true);
                      setIsNeedStaffCheckModel(true);
                    }
                    else{
                      const rsData = await apiSaveOrder(saveData);
                      if (rsData) {
                        setState((curr) => {
                          return {
                            ...curr,
                            posCode: rsData.posCode,
                            checkAt: rsData.checkTime,
                          };
                        });
                        // window.print();

                        // 儲存預點單完成並列印
                        const alert = await AsyncModel({
                          title:
                            globalState.langFile[
                              globalState.staffInfo.checkOrderData.isAddOrder
                                ? "pages.staffCheckOrder.step3.AddOrderEnd"
                                : "pages.staffCheckOrder.step3.savedOrder"
                            ],
                          showConfirmBtn: false, 
                          confirmBtnText:
                            globalState.langFile[
                              "pages.staffCheckOrder.step3.logOut"
                            ],
                          autoClose: true,
                          autoCloseTime: 500,
                        });
                        if (alert) {
                          dispatchGlobal({ type: "LOGOUT" });
                          AsyncModelClose();
                        }
                      }
                    }
                  } catch (err) {}
                  AsyncModelClose();
                }
              }}
            />
          }
        </div>
      </div>

      {/* 特口彈跳視窗 */}
      {(() => {
        if (!state.specPopupSetting.toggle) return null;
        return (
          <Tool_CusSp
            productName={state.specPopupSetting.productName}
            specName={state.specPopupSetting.specName}
            takeoutTaste={state.specPopupSetting.takeoutTaste}
            dineInTaste={state.specPopupSetting.dineInTaste}
            takeoutState={
              state.specPopupSetting.applyMode === 3
                ? true
                : state.currModify.takeout
            } // 若僅限外帶，預設給true
            disableTakeoutState={state.specPopupSetting.disableTakeoutState}
            applyModeState={state.specPopupSetting.applyMode}
            selectedItems={state.currModify.taste}
            onClose={(e) => {
              setState((curr) => {
                return {
                  ...curr,
                  currModify: null,
                  isAddNew: false,
                  specPopupSetting: {
                    toggle: false,
                    productName: "",
                    specName: "",
                    dineInTaste: [],
                    takeoutTaste: [],
                  },
                };
              });
            }}
            onSelectItem={async (e) => {
              const resource = e.takeoutState ? state.takeout : state.dineIn;
              let deep = _.cloneDeep(resource);
              console.log("onSelectItem", state);
              // 新增組合
              if (state.isAddNew) {
                e.taste.sort();
                // 找到要新增的產品
                let findCurrentProduct = deep.find(
                  (f) => f.id === state.currModify.productId
                );
                console.log("findCurrentProduct", findCurrentProduct);
                // 找到要新增的規格
                let findCurrentSpec;
                if (findCurrentProduct) {
                  findCurrentSpec = findCurrentProduct.specification.find(
                    (f) => f.id === state.currModify.specId
                  );
                  console.log(findCurrentSpec);
                }
                if (!findCurrentProduct) {
                  console.log("did not have this product");
                  let originalSource = e.takeoutState
                    ? state.dineIn
                    : state.takeout;
                  let findOriginalProduct = originalSource.find(
                    (f) => f.id === state.currModify.productId
                  );
                  let findOriginalSpec = findOriginalProduct.specification.find(
                    (f) => f.id === state.currModify.specId
                  );
                  let product = {
                    ...findOriginalProduct,
                    specification: [
                      {
                        ...findOriginalSpec,
                        combination: [
                          {
                            takeout: e.takeoutState,
                            quantity: 1,
                            taste: e.taste,
                          },
                        ],
                      },
                    ],
                  };
                  deep = [...deep, product];
                  deep.sort((a, b) => {
                    return a.id > b.id ? 1 : -1;
                  });
                } else if (!findCurrentSpec) {
                  console.log("did not have this spec");
                  let originalSource = e.takeoutState
                    ? state.dineIn
                    : state.takeout;
                  let findOriginalProduct = originalSource.find(
                    (f) => f.id === state.currModify.productId
                  );
                  let findOriginalSpec = findOriginalProduct.specification.find(
                    (f) => f.id === state.currModify.specId
                  );
                  let spec = {
                    ...findOriginalSpec,
                    combination: [
                      {
                        takeout: e.takeoutState,
                        quantity: 1,
                        taste: e.taste,
                      },
                    ],
                  };
                  findCurrentProduct.specification = [
                    ...findCurrentProduct.specification,
                    spec,
                  ];
                  findCurrentProduct.specification.sort((a, b) => {
                    return a.id > b.id ? 1 : -1;
                  });
                } else {
                  findCurrentSpec.combination = [
                    ...findCurrentSpec.combination,
                    {
                      takeout: e.takeoutState,
                      quantity: 1,
                      taste: e.taste,
                    },
                  ];
                }
                // 判斷要更新的用餐類型(內用||外帶)
                if (e.takeoutState) {
                  setState((curr) => {
                    return {
                      ...curr,
                      currModify: null,
                      isAddNew: false,
                      specPopupSetting: {
                        toggle: false,
                        productName: "",
                        specName: "",
                        dineInTaste: [],
                        takeoutTaste: [],
                      },
                      takeout: merge(deep),
                    };
                  });
                } else {
                  setState((curr) => {
                    return {
                      ...curr,
                      currModify: null,
                      isAddNew: false,
                      specPopupSetting: {
                        toggle: false,
                        productName: "",
                        specName: "",
                        dineInTaste: [],
                        takeoutTaste: [],
                      },
                      dineIn: merge(deep),
                    };
                  });
                }
              }
              // 修改
              else {
                console.log("onSelectItem Edit");
                // 找到要修改的產品
                let findCurrentProduct = deep.find(
                  (f) => f.id === state.currModify.productId
                );
                // 找到要修改的規格
                let findCurrentSpec;
                if (findCurrentProduct) {
                  findCurrentSpec = findCurrentProduct.specification.find(
                    (f) => f.id === state.currModify.specId
                  );
                }
                // 找到要修改的組合
                let findCurrrentCombi;
                if (findCurrentSpec) {
                  findCurrrentCombi = findCurrentSpec.combination.find((f) => {
                    return (
                      f.takeout === state.currModify.takeout &&
                      f.taste.sort().toString() ===
                        state.currModify.taste.sort().toString() &&
                      f.quantity === state.currModify.quantity
                    );
                  });
                }
                findCurrrentCombi.taste = e.taste;
                // 判斷此產品是否存在
                if (
                  !findCurrentProduct ||
                  !findCurrentSpec ||
                  !findCurrrentCombi
                )
                  return null;
                // 判斷要更新的用餐類型(內用||外帶)
                if (e.takeoutState) {
                  setState((curr) => {
                    return {
                      ...curr,
                      currModify: null,
                      isAddNew: false,
                      specPopupSetting: {
                        toggle: false,
                        productName: "",
                        specName: "",
                        dineInTaste: [],
                        takeoutTaste: [],
                      },
                      takeout: merge(deep),
                    };
                  });
                } else {
                  setState((curr) => {
                    return {
                      ...curr,
                      currModify: null,
                      isAddNew: false,
                      specPopupSetting: {
                        toggle: false,
                        productName: "",
                        specName: "",
                        dineInTaste: [],
                        takeoutTaste: [],
                      },
                      dineIn: merge(deep),
                    };
                  });
                }
              }
              // const total =
              //   totalPrice().dineInTotalPrice +
              //   totalPrice().dineInSpecPrice +
              //   totalPrice().takeoutInTotalPrice +
              //   totalPrice().takeoutInSpecPrice;
              /*
              const { staffInfo } = globalState;
              const saveData = {
                waiterID: staffInfo.checkOrderStaff.staffCode,
                orderCode: staffInfo.orderCode,
                remark: state.orderRemark,
                totalPrice: total,
                dineIn: handlePostOrder(state.dineIn),
                takeout: handlePostOrder(state.takeout),
                status: 6,
                storeID: staffInfo.checkOrderBranch.branchCode,
                createAt: moment(staffInfo.checkOrderData.orderTime).format(
                  "YYYY/MM/DD"
                ),
              };
              try {
                await apiSaveOrder(saveData);
              } catch (err) {}
              */
            }}
            // onSelectItem={newTaste => {
            //   // 新增組合
            //   if (state.isAddNew) {
            //     // 內用 / 外帶
            //     let whichTaste = state.currModify.takeout
            //       ? state.takeout
            //       : state.dineIn;
            //     whichTaste = _.cloneDeep(whichTaste);

            //     // 有無此產品
            //     let isProductExist = whichTaste.find(
            //       product => product.id === state.currModify.productId
            //     );
            //     let isSpecExist;
            //     // 有此產品 -> 繼續找出有無此產品 -> 規格
            //     if (isProductExist) {
            //       isSpecExist = isProductExist.specification.find(
            //         spce => spce.id === state.currModify.specId
            //       );
            //     }

            //     // product not exist
            //     if (!isProductExist) {
            //       console.log('did not have this product');
            //       let originalSource = state.currModify.takeout
            //         ? state.dineIn
            //         : state.takeout;
            //       let findOriginalProduct = originalSource.find(
            //         f => f.id === state.currModify.productId
            //       );
            //       let findOriginalSpec = findOriginalProduct.specification.find(
            //         f => f.id === state.currModify.specId
            //       );
            //       let product = {
            //         ...findOriginalProduct,
            //         specification: [
            //           {
            //             ...findOriginalSpec,
            //             combination: [
            //               {
            //                 takeout: state.currModify.takeout,
            //                 quantity: state.currModify.quantity,
            //                 taste: newTaste
            //               }
            //             ]
            //           }
            //         ]
            //       };
            //       whichTaste = [...whichTaste, product];
            //       whichTaste.sort((a, b) => {
            //         return a.id > b.id ? 1 : -1;
            //       });
            //     } else if (!isSpecExist) {
            //       console.log('did not have this spec');
            //       let originalSource = state.currModify.takeout
            //         ? state.dineIn
            //         : state.takeout;
            //       let findOriginalProduct = originalSource.find(
            //         f => f.id === state.currModify.productId
            //       );
            //       let findOriginalSpec = findOriginalProduct.specification.find(
            //         f => f.id === state.currModify.specId
            //       );
            //       let spec = {
            //         ...findOriginalSpec,
            //         combination: [
            //           {
            //             takeout: state.currModify.takeout,
            //             quantity: state.currModify.quantity,
            //             taste: newTaste
            //           }
            //         ]
            //       };
            //       isProductExist.specification = [
            //         ...isProductExist.specification,
            //         spec
            //       ];
            //       isProductExist.specification.sort((a, b) => {
            //         return a.id > b.id ? 1 : -1;
            //       });
            //     } else {
            //       isSpecExist.combination = [
            //         ...isSpecExist.combination,
            //         {
            //           takeout: state.currModify.takeout,
            //           quantity: state.currModify.quantity,
            //           taste: newTaste
            //         }
            //       ];
            //     }
            //     // 新增內用 || 外帶
            //     if (state.currModify.takeout) {
            //       setState(curr => {
            //         return {
            //           ...curr,
            //           takeout: merge(whichTaste),
            //           currModify: null,
            //           specPopupSetting: {
            //             ...state.specPopupSetting,
            //             toggle: false
            //           }
            //         };
            //       });
            //     } else {
            //       setState(curr => {
            //         return {
            //           ...curr,
            //           dineIn: merge(whichTaste),
            //           currModify: null,
            //           specPopupSetting: {
            //             ...state.specPopupSetting,
            //             toggle: false
            //           }
            //         };
            //       });
            //     }
            //   } else {
            //     // 修改
            //     let whichTaste = state.currModify.takeout
            //       ? state.takeout
            //       : state.dineIn;
            //     whichTaste = _.cloneDeep(whichTaste);

            //     let productIndex = whichTaste.findIndex(
            //       productIndex => productIndex.id === state.currModify.productId
            //     );
            //     let specIndex = whichTaste[
            //       productIndex
            //     ].specification.findIndex(
            //       specIndex => specIndex.id === state.currModify.specId
            //     );
            //     if (productIndex > -1 && specIndex > -1) {
            //       let targetCombi = whichTaste[productIndex].specification[
            //         specIndex
            //       ].combination.find(f => {
            //         return (
            //           f.takeout === state.currModify.takeout &&
            //           f.taste.sort().toString() ===
            //             state.currModify.taste.sort().toString() &&
            //           f.quantity === state.currModify.quantity
            //         );
            //       });
            //       targetCombi.taste = newTaste;
            //     }
            //     setState(curr => {
            //       if (state.currModify.takeout) {
            //         return {
            //           ...curr,
            //           takeout: merge(whichTaste),
            //           specPopupSetting: {
            //             ...state.specPopupSetting,
            //             toggle: false
            //           }
            //         };
            //       } else {
            //         return {
            //           ...curr,
            //           dineIn: merge(whichTaste),
            //           specPopupSetting: {
            //             ...state.specPopupSetting,
            //             toggle: false
            //           }
            //         };
            //       }
            //     });
            //   }
            // }}
          />
        );
      })()}

      {/* popup add remark */}
      <Modal
        className="w-100 h-100 pl-2 pr-2 d-flex justify-content-center align-items-center"
        style={{ margin: "0 auto" }}
        isOpen={state.popupRemark.toggle}
      >
        <ModalHeader>
          <FormattedMessage id="popup.msgAddNote" />
        </ModalHeader>
        <ModalBody>
          <CusInput
            value={state.popupRemark.remark}
            onChange={(event) => {
              let val = event.target.value;
              setState((curr) => {
                return {
                  ...curr,
                  popupRemark: {
                    ...curr.popupRemark,
                    remark: val,
                  },
                };
              });
            }}
          />
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <CusButton.White
            children={<FormattedMessage id="popup.buttonCancel" />}
            onClick={() => {
              setState((curr) => {
                return {
                  ...curr,
                  popupRemark: {
                    orderType: null,
                    toggle: false,
                    target: null,
                    remark: "",
                  },
                };
              });
            }}
          />

          <CusButton.Red
            children={<FormattedMessage id="popup.buttonConfirm" />}
            onClick={() => {
              let { orderType, toggle, target, remark } = state.popupRemark;
              if (orderType === "dineIn") {
                const findTarget = state.dineIn.find((f) => f.id === target);
                findTarget.remark = remark;
                setState((curr) => {
                  return {
                    ...curr,
                    popupRemark: {
                      orderType: null,
                      toggle: false,
                      target: null,
                      remark: "",
                    },
                  };
                });
              } else if (orderType === "takeout") {
                const findTarget = state.takeout.find((f) => f.id === target);
                findTarget.remark = remark;
                setState((curr) => {
                  return {
                    ...curr,
                    popupRemark: {
                      orderType: null,
                      toggle: false,
                      target: null,
                      remark: "",
                    },
                  };
                });
              } else if (orderType === "order") {
                console.log(remark);
                setState((curr) => {
                  return {
                    ...curr,
                    orderRemark: remark,
                    popupRemark: {
                      orderType: null,
                      toggle: false,
                      target: null,
                      remark: "",
                    },
                  };
                });
              }
            }}
          />
        </ModalFooter>
      </Modal>
       {/* 其他需求彈跳視窗 */}

       {isNeedStaffCheckModel == true ? (
        <Tool_extraNeedStaff
          data={globalState.staffInfo.selectedExtraQ}
          allData = {state.extraDataList}
          setIsNeedStaffCheckModel={setIsNeedStaffCheckModel}
          needStaffCheckID={needStaffCheckID}
          //setneedStaffCheckID={setneedStaffCheckID}
          setneedStaffCheckID={(ansId)=>{   
            let ans = globalState.staffInfo.selectedExtraA;

            if(!ans){  
              ans = [];
            }

            if(ansId !== 0){
              const ansItem = {
                qusetionId: globalState.staffInfo.selectedExtraQ.id,
                ansId:ansId
              }

              if(!ans.some(x=>x.qusetionId === ansItem.qusetionId)){
                ans.push(ansItem);
              }
              else{
                if(!ans.some(x=>x.ansId === ansItem.ansId)){
                  ans = ans.filter(x=>x.qusetionId != ansItem.qusetionId);
                  ans.push(ansItem);
                }
              }
            }
            else{
              if(ans.some(x=>x.qusetionId === globalState.staffInfo.selectedExtraQ.id)){
                ans = ans.filter(x=>x.qusetionId !== globalState.staffInfo.selectedExtraQ.id);
              }
            }

            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "staffInfo",
                  val: {
                    ...globalState.staffInfo,
                    selectedExtraA: ans,
                  },
                },
              ],
            });
          }}
          isSentOrder={isSentOrder}
          sentOrder={async () => {const waittingAlert = AsyncModel({
            content: (
              <div className="w-100 d-flex justify-content-center">
                <ReactLoading
                  type="spokes"
                  color="#ccc"
                  height="100px"
                  width="100px"
                />
              </div>
            ),
            footerMsg:
              globalState.langFile[
                globalState.staffInfo.checkOrderData.isAddOrder
                  ? "pages.staffCheckOrder.step3.AddOrderLoading"
                  : "pages.staffCheckOrder.loading"
              ],
            showConfirmBtn: false,
          });
          const total =
            totalPrice().dineInTotalPrice +
            totalPrice().dineInSpecPrice +
            totalPrice().takeoutInTotalPrice +
            totalPrice().takeoutInSpecPrice;
          // 回傳訂單 => 回傳成功 => 重置staff登入狀態至分店

          const handledOrderDineIn = handlePostOrder(state.dineIn);
          const handledOrderTakeout = handlePostOrder(state.takeout);
          if (
            handledOrderDineIn.length <= 0 &&
            handledOrderTakeout.length <= 0
          ) {
            console.error("OrderInfo error.");
            dispatchGlobal({
              type: "UPDATE",
              payload: [{ key: "errMsg", val: 415 }],
            });
            props.history.push("/staff/error");
          } else {
            const { staffInfo } = globalState;
            const saveData = {
              waiterID: staffInfo.checkOrderStaff.staffCode,
              orderCode: staffInfo.orderCode,
              remark: state.orderRemark,
              totalPrice: total,
              tableNumber: state.tableNo
                ? `${state.tableNo}-${state.subTableNo}`
                : "",
              dineIn: handledOrderDineIn,
              takeout: handledOrderTakeout,
              status: 2,
              storeID: staffInfo.checkOrderBranch.branchCode,
              createAt: moment(staffInfo.checkOrderData.orderTime).format(
                "YYYY/MM/DD"
              ),
              orderExtraList: getExtraSelectedNew(staffInfo.selectedExtraA),
            };

            // 若是QRCODE點餐，帶人數跟國別進request
            if (globalState.staffInfo.checkOrderData.orderType === 3) {
              saveData.adultsCount = state.numberOfAdult || 0;
              saveData.childCount = state.numberOfChild || 0;
              saveData.countryID = state.countrySelected.country;
            }

            try {
              let q = state.extraDataList.map(x=>x.id); 
              let a = staffInfo.selectedExtraA.map(x=>x.qusetionId);                    
              let result = q.concat(a).filter(v=>!q.includes(v) || !a.includes(v));
              if(result.length > 0){    
                let first = state.extraDataList.filter(x=>x.id == result[0])[0];
                console.debug(first);                     
                dispatchGlobal({
                  type: "UPDATE",
                  payload: [
                    {
                      key: "staffInfo",
                      val: {
                        ...globalState.staffInfo,
                        selectedExtraQ:first
                      },
                    },
                  ],
                });
                setIsSentOrder(true);
                setIsNeedStaffCheckModel(true);
              }
              else{
                const rsData = await apiSaveOrder(saveData);
                if (rsData) {
                  setState((curr) => {
                    return {
                      ...curr,
                      posCode: rsData.posCode,
                      checkAt: rsData.checkTime,
                    };
                  });
                  // window.print();

                  // 儲存預點單完成並列印
                  const alert = await AsyncModel({
                    title:
                      globalState.langFile[
                        globalState.staffInfo.checkOrderData.isAddOrder
                          ? "pages.staffCheckOrder.step3.AddOrderEnd"
                          : "pages.staffCheckOrder.step3.savedOrder"
                      ],
                    showConfirmBtn: false, 
                    confirmBtnText:
                      globalState.langFile[
                        "pages.staffCheckOrder.step3.logOut"
                      ],
                    autoClose: true,
                    autoCloseTime: 500,
                  });
                  if (alert) {
                    dispatchGlobal({ type: "LOGOUT" });
                    AsyncModelClose();
                  }
                }
              }
            } catch (err) {}
            AsyncModelClose();
          }
        }}
          updateAddOrderExtra={()=>{}}
        />
      ) : (
        ""
      )}

       {(() => {
        if (!state.needPopupSetting.toggle) return null;

        return (
          <Tool_CusOtherNeed_staff
            needName={state.needPopupSetting.needName}
            subArray={state.needPopupSetting.subArray}
            needType={state.needPopupSetting.needType}
            needId={state.needPopupSetting.needId}
            onClose={() => {
              setState((curr) => {
                return {
                  ...curr,
                  needPopupSetting: {
                    toggle: false,
                    productName: "",
                    specName: "",
                    // dineInTaste: [],
                    // takeoutTaste: [],
                  },
                };
              });
            }}
            updateExtraSingle={updateExtraSingle}
            updateExtra={updateExtra}
          />
        );
      })()}
    </>
  );
}

export default withRouter(StaffCheckStep_3);
